<div class="w-lg-50">
  <p class="font-size-sm">The filter preferences selected here will be the default filters applied where relevant throughout NESS.  These filter preferences are saved to your user profile and you can update them at any time.</p>
  <form #filterForm="ngForm" class="mb-3">
    <div class="row g-sm-2">
      <label for="FieldDivisionID" class="col-form-label col-sm-4 col-md-3 text-sm-end"><span class="visually-hidden">Filter by </span>Field Division:</label>
      <div class="col-sm-8 col-md-9">
        <select class="form-select" id="FieldDivisionID" [value]="filterModel.fieldDivisionID" name="fieldDivisionID" (change)="onSelectFieldDivision($event.target)">
          <option value="all">All</option>
          <ng-container *ngIf="filterService.fieldDivisions$.asObservable() | async as fieldDivisions">
            <option *ngFor="let fieldDiv of fieldDivisions" [value]="fieldDiv.FieldDivisionID" [selected]="filterModel.fieldDivisionID == fieldDiv.FieldDivisionID">{{fieldDiv.FieldDivisionName}}</option>
          </ng-container>
        </select>
      </div>
      <label for="FieldDivisionGroups" class="col-form-label col-sm-4 col-md-3 text-sm-end"><span class="visually-hidden">Filter by </span>Field Division Group:</label>
      <div class="col-sm-8 col-md-9">
        <ng-container *ngIf="filterService.fieldDivisionGroups$.asObservable() | async as fdGroups ">
          <p-multiSelect [(ngModel)]="filterModel.fieldDivisionGroups"
                         [options]="fdGroups"
                         optionLabel="GroupName"
                         optionDisabled="Inactive"
                         name="fieldDivisionGroups"
                         placeholder="All"
                         dataKey="IntelligenceReportATFReferralGroupsID"
                         inputId="FieldDivisionGroups"
                         styleClass="form-select"
                         ariaFilterLabel="Filter by field division group"
                         [maxSelectedLabels]="3"
                         [showToggleAll]="false"
                         [resetFilterOnHide]="true"
                         filterBy="GroupName"
                         (onChange)="onSelectFieldDivisionGroup($event)"
                         [virtualScroll]="true"
                         [virtualScrollItemSize]="30"
                         appendTo="body">
            <ng-template let-selectedFDGroups pTemplate="selectedItems">
              <ng-container *ngIf="selectedFDGroups?.length <= 3">
                <span *ngFor="let selectedFDGroup of selectedFDGroups; let last = last">{{selectedFDGroup.GroupName}} ({{selectedFDGroup.Inactive | booleanTransform: 'Inactive' : 'Active'}})<span *ngIf="!last">;&nbsp;</span></span>
              </ng-container>
              <ng-container *ngIf="selectedFDGroups?.length > 3">
                {{ selectedFDGroups?.length }} items selected
              </ng-container>
              <ng-container *ngIf="!selectedFDGroups || selectedFDGroups?.length === 0">
                All
              </ng-container>
            </ng-template>
            <ng-template let-group pTemplate="item">
              <div>{{group.GroupName}} ({{group.Inactive | booleanTransform: 'Inactive' :'Active'}})</div>
            </ng-template>
          </p-multiSelect>
        </ng-container>
      </div>
      <label for="StateID" class="col-form-label col-sm-4 col-md-3 text-sm-end"><span class="visually-hidden">Filter by </span>State:</label>
      <div class="col-sm-8 col-md-9">
        <select class="form-select" id="StateID" [value]="filterModel.stateID" name="stateID" (change)="onSelectState($event.target)">
          <option value="all">All</option>
          <ng-container *ngIf="filterService.states$.asObservable() | async as states">
            <option *ngFor="let state of states" [value]="state.StateID" [selected]="filterModel.stateID == state.StateID">{{state.StateName}}</option>
          </ng-container>
        </select>
      </div>
      <label for="Counties" class="col-form-label col-sm-4 col-md-3 text-sm-end"><span class="visually-hidden">Filter by </span>County:</label>
      <div class="col-sm-8 col-md-9">
        <ng-container *ngIf="filterService.counties$.asObservable() | async as counties">
          <p-multiSelect [(ngModel)]="filterModel.counties"
                         [options]="counties"
                         optionLabel="CountyName"
                         name="counties"
                         placeholder="All"
                         dataKey="CountyID"
                         inputId="Counties"
                         styleClass="form-select"
                         ariaFilterLabel="Filter by county name"
                         [maxSelectedLabels]="3"
                         [showToggleAll]="false"
                         (onChange)="onSelectCounties($event)"
                         [resetFilterOnHide]="true"
                         filterBy="CountyName,ENESS_REF_State.StateAbbreviation"
                         [virtualScroll]="true"
                         [virtualScrollItemSize]="30"
                         appendTo="body">
            <ng-template let-selectedCounties pTemplate="selectedItems">
              <ng-container *ngIf="selectedCounties?.length <= 3">
                <span *ngFor="let county of selectedCounties; last as isLast">{{county.CountyName}}, {{county.ENESS_REF_State.StateAbbreviation}}<span *ngIf="!isLast">;&nbsp;</span> </span>
              </ng-container>
              <ng-container *ngIf="selectedCounties?.length > 3">{{ selectedCounties.length }} items selected</ng-container>
              <ng-container *ngIf="!selectedCounties || selectedCounties?.length === 0">All</ng-container>
            </ng-template>
            <ng-template let-county pTemplate="item">
              <div>{{county.CountyName}}, {{county.ENESS_REF_State?.StateAbbreviation}}</div>
            </ng-template>
          </p-multiSelect>
        </ng-container>
      </div>
      <label for="Agencies" class="col-form-label col-sm-4 col-md-3 text-sm-end"><span class="visually-hidden">Filter by </span>LE Agency:</label>
      <div class="col-sm-8 col-md-9">
        <ng-container *ngIf="filterService.agencies$.asObservable() | async as agencies">
          <p-multiSelect [(ngModel)]="filterModel.agencies"
                         [options]="agencies"
                         optionLabel="AgencyName"
                         name="agencies"
                         placeholder="All"
                         dataKey="AgencyID"
                         inputId="Agencies"
                         styleClass="form-select"
                         ariaFilterLabel="Filter by law enforcement agency name"
                         [maxSelectedLabels]="3"
                         [showToggleAll]="false"
                         (onChange)="onSelectAgencies($event)"
                         [resetFilterOnHide]="true"
                         filterBy="AgencyName"
                         [virtualScroll]="true"
                         [virtualScrollItemSize]="30"
                         appendTo="body">
            <ng-template let-selectedAgencies pTemplate="selectedItems">
              <ng-container *ngIf="selectedAgencies?.length <= 3">
                <span *ngFor="let agency of selectedAgencies; last as isLast">{{agency.AgencyName}}<span *ngIf="!isLast">;&nbsp;</span> </span>
              </ng-container>
              <ng-container *ngIf="selectedAgencies?.length > 3">{{ selectedAgencies.length }} items selected</ng-container>
              <ng-container *ngIf="!selectedAgencies || selectedAgencies?.length === 0">All</ng-container>
            </ng-template>
          </p-multiSelect>
        </ng-container>
      </div>
      <div class="mt-3 offset-sm-4 offset-md-3 col-sm-8 col-md-9">
        <button type="button" class="btn btn-success mb-2" [disabled]="isLoading"  (click)="saveFilterPreferences()" title="Save Filter Preferences">Save<span class="visually-hidden"> filter preferences</span></button>
        <button type="button" class="btn btn-secondary mb-2" [disabled]="isLoading" (click)="resetFilters()" title="Cancel filter preference changes">Cancel<span class="visually-hidden"> filter  preference changes</span></button>
      </div>
    </div>
  </form>
</div>
